import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  /** Makes the stack full width & full height */
  sizeFull?: boolean;
  /** Center the content. alias for `justify-center items-center` */
  center?: boolean;
  /** Adds the `flex-wrap` class */
  wrap?: boolean;
}

export interface BoxProps extends HTMLAttributes<HTMLDivElement> {
  sizeFull?: boolean;
}

export interface GridProps extends HTMLAttributes<HTMLDivElement> {
  sizeFull?: boolean;
}

export const XStack = forwardRef<HTMLDivElement, StackProps>(
  ({ className, sizeFull, wrap, center, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex',
        {
          'items-center justify-center': center,
          'flex-wrap': wrap,
          'size-full': sizeFull,
        },
        className
      )}
      {...props}
    />
  )
);
XStack.displayName = 'XStack';

export const YStack = forwardRef<HTMLDivElement, StackProps>(
  ({ className, wrap, sizeFull, center, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex flex-col',
        {
          'items-center justify-center': center,
          'flex-wrap': wrap,
          'size-full': sizeFull,
        },
        className
      )}
      {...props}
    />
  )
);
YStack.displayName = 'YStack';

export const Box = forwardRef<HTMLDivElement, BoxProps>(
  ({ className = '', sizeFull, ...props }, ref) => (
    <div
      ref={ref}
      className={`${sizeFull ? 'size-full' : ''} ${className}`}
      {...props}
    />
  )
);
Box.displayName = 'Box';

export const Grid = forwardRef<HTMLDivElement, GridProps>(
  ({ className, sizeFull, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('grid', { 'size-full': sizeFull }, className)}
      {...props}
    />
  )
);
Grid.displayName = 'Grid';
